import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useFetchTAndCPdf } from 'Features/ContractRelease/Services/release.service';
import View from './CheckPDF.view';

const ViewTAndC = ({ currentContract, viewTAndC, handlePDFChecked, handleClosedPDF, grouping }) => {
	const { description, type, template, year } = currentContract;
	const [pdf, setPdf] = useState(null);

	const title = `${description} (${type}), ${template} (${year})`;
	const { isLoading, isSuccess } = useFetchTAndCPdf(year, grouping, type, setPdf);
	const isFail = !isLoading && !isSuccess;

	const handleCancelWithdrawn = () => {
		return false;
	};

	const updateCheckedCount = () => {
		return 0;
	};

	return (
		<View
			title={title}
			pdf={pdf}
			isLoading={isLoading}
			isSuccess={isSuccess}
			isFail={isFail}
			isChecking={false}
			handlePDFChecked={handlePDFChecked}
			handleClosedPDF={handleClosedPDF}
			grouping={grouping}
			showModal={false}
			handleCancelConfirmed={handleClosedPDF}
			handleCancelWithdrawn={handleCancelWithdrawn}
			updateCheckedCount={updateCheckedCount}
		/>
	);
};

ViewTAndC.propTypes = {
	currentContract: PropTypes.any,
	viewTAndC: PropTypes.bool.isRequired,
	handlePDFChecked: PropTypes.func.isRequired,
	handleClosedPDF: PropTypes.func.isRequired,
	grouping: PropTypes.string.isRequired
};

export default ViewTAndC;
